"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactTransitionGroup = require("react-transition-group");
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _decorators = require("../../../decorators");
var _find = _interopRequireDefault(require("lodash/find"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _Icon = _interopRequireDefault(require("../../Icon"));
var _styles = require("./styles");
var _dec, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11; //helpers
//lodash
//components
//styled-components
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var VideoPlayerComponent = (_dec = (0, _mobxReact.inject)('store'), _dec(_class = (0, _mobxReact.observer)(_class = (0, _decorators.styleable)(_class = (_class2 = /*#__PURE__*/function (_Component) {
  function VideoPlayerComponent(props) {
    var _this;
    _classCallCheck(this, VideoPlayerComponent);
    _this = _callSuper(this, VideoPlayerComponent, [props]);
    _initializerDefineProperty(_this, "isFullscreen", _descriptor, _this);
    _initializerDefineProperty(_this, "showOverlay", _descriptor2, _this);
    _initializerDefineProperty(_this, "videoEnded", _descriptor3, _this);
    _initializerDefineProperty(_this, "setShowOverlay", _descriptor4, _this);
    _initializerDefineProperty(_this, "toggleOverlay", _descriptor5, _this);
    _defineProperty(_this, "playPromise", void 0);
    _initializerDefineProperty(_this, "listenToVideoEvents", _descriptor6, _this);
    _defineProperty(_this, "getMinutesAndSeconds", function (value) {
      var minutes = parseInt(value / 60, 10);
      var seconds = parseInt(value % 60, 10);
      return {
        minutes: minutes,
        seconds: seconds
      };
    });
    _defineProperty(_this, "compareTimes", function (milliseconds1, milliseconds2) {
      var time1 = _this.getMinutesAndSeconds(milliseconds1);
      var time2 = _this.getMinutesAndSeconds(milliseconds2);
      return time1.minutes === time2.minutes && time1.seconds === time2.seconds;
    });
    _defineProperty(_this, "createVideoPlayPromise", function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        currentTime = _ref.currentTime;
      return new Promise(function (resolve, reject) {
        try {
          if (typeof currentTime !== 'undefined') {
            _this.video.currentTime = 0;
          }
          _this.video.play();
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    });
    _initializerDefineProperty(_this, "fullScreenHandler", _descriptor7, _this);
    _defineProperty(_this, "onFullScreenChange", function (isFullScreen) {
      if (!isFullScreen) {
        if (_this.videoEnded) {
          _this.resetVideo();
        } else {
          var app = _this.props.store.app;
          app.setDisableResizers(false);
          _this.setShowOverlay(false);
          if (_this.video) {
            _this.playPromise = _this.createVideoPlayPromise();
          }
        }
      }
    });
    _defineProperty(_this, "listenToFullscreenChange", function () {
      document.addEventListener('fullscreenchange', _this.fullScreenHandler, false);
      document.addEventListener('webkitfullscreenchange', _this.fullScreenHandler, false);
      document.addEventListener('mozfullscreenchange', _this.fullScreenHandler, false);
      _this.video.addEventListener('webkitendfullscreen', _this.fullScreenHandler, false);
    });
    _initializerDefineProperty(_this, "onVideoEnded", _descriptor8, _this);
    _initializerDefineProperty(_this, "reset", _descriptor9, _this);
    _defineProperty(_this, "resetVideo", function () {
      _this.video.currentTime = 0;
    });
    _initializerDefineProperty(_this, "replay", _descriptor10, _this);
    _initializerDefineProperty(_this, "requestFullScreen", _descriptor11, _this);
    (0, _mobx.makeObservable)(_this);
    return _this;
  }
  _inherits(VideoPlayerComponent, _Component);
  return _createClass(VideoPlayerComponent, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var wasCurrent = this.props.autoplayVideo;
      if (nextProps.autoplayVideo && this.video && !this.videoEnded) {
        this.replay();
      }
      if (wasCurrent && !nextProps.autoplayVideo) {
        this.reset();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var autoplayVideo = this.props.autoplayVideo;
      if (this.video) {
        this.listenToVideoEvents();
        this.listenToFullscreenChange();
      }
      if (autoplayVideo && this.video && !this.videoEnded) {
        this.replay();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        src = _this$props.src,
        type = _this$props.type,
        poster = _this$props.poster,
        muted = _this$props.muted;
      var showOverlay = this.showOverlay,
        videoEnded = this.videoEnded;
      return /*#__PURE__*/_react["default"].createElement(_styles.VideoPlayer, null, /*#__PURE__*/_react["default"].createElement(_styles.Video, _extends({
        onClick: this.toggleOverlay,
        ref: function ref(_ref2) {
          return _this2.video = _ref2;
        },
        playsInline: true,
        poster: poster
      }, muted && {
        muted: muted
      }), /*#__PURE__*/_react["default"].createElement("source", {
        src: src,
        type: type
      }), "Your browser does not support the video tag."), /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransitionGroup, {
        transitionName: "fadein",
        transitionEnterTimeout: 200,
        transitionLeaveTimeout: 300
      }, (showOverlay || videoEnded) && /*#__PURE__*/_react["default"].createElement(_styles.Overlay, {
        onClick: this.toggleOverlay
      }, /*#__PURE__*/_react["default"].createElement(_styles.ReplayIcon, {
        onClick: this.replay
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: 'refresh'
      })), !videoEnded && /*#__PURE__*/_react["default"].createElement(_styles.FullScreenIcon, {
        onClick: this.requestFullScreen
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: 'resize'
      })))));
    }
  }]);
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "isFullscreen", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "showOverlay", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "videoEnded", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "setShowOverlay", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;
    return function (value) {
      return _this3.showOverlay = value;
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "toggleOverlay", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;
    return function () {
      return _this4.showOverlay = !_this4.showOverlay;
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "listenToVideoEvents", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;
    return function () {
      _this5.video.onended = function () {
        if (_this5.props.autoplayVideo) {
          _this5.onVideoEnded();
        }
      };
      _this5.video.onplay = function () {
        if (_this5.props.autoplayVideo) {
          _this5.videoEnded = false;
        }
      };
      _this5.video.onseeking = (0, _debounce["default"])(function () {
        if (_this5.props.autoplayVideo && _this5.isFullscreen) {
          var seekedToTheEnd = _this5.compareTimes(_this5.video.duration, _this5.video.currentTime);
          _this5.videoEnded = seekedToTheEnd;
        }
      }, 500);
    };
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "fullScreenHandler", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this6 = this;
    return function () {
      var isFullScreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
      _this6.isFullscreen = isFullScreen;
      _this6.onFullScreenChange(isFullScreen);
    };
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "onVideoEnded", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this7 = this;
    return function () {
      _this7.setShowOverlay(true);
      _this7.videoEnded = true;
    };
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "reset", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this8 = this;
    return function () {
      _this8.setShowOverlay(false);
      _this8.resetVideo();
      _this8.videoEnded = false;
      if (_this8.playPromise) {
        _this8.playPromise.then(function () {
          _this8.video.pause();
        });
      }
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "replay", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this9 = this;
    return function (e) {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this9.videoEnded = false;
      _this9.playPromise = _this9.createVideoPlayPromise({
        currentTime: 0
      }).then(function () {
        _this9.setShowOverlay(false);
      })["catch"](function () {
        _this9.setShowOverlay(true);
      });
    };
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "requestFullScreen", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this10 = this;
    return function (e) {
      var app = _this10.props.store.app;
      app.setDisableResizers(true);
      e.stopPropagation();
      e.preventDefault();
      var possibleFns = ['requestFullscreen', 'mozRequestFullScreen', 'webkitRequestFullscreen', 'webkitEnterFullScreen'];
      var fullscreenFn = (0, _find["default"])(possibleFns, function (fn) {
        return _this10.video[fn];
      });
      _this10.video[fullscreenFn]();
      _this10.setShowOverlay(false);
    };
  }
})), _class2)) || _class) || _class) || _class);
var _default = exports["default"] = VideoPlayerComponent;
//# sourceMappingURL=index.js.map